/**
 * Test IDs for QA automation.
 */
export const testIds = {
  goodProfilesListNewCommodity: "good-profiles-list-new-commodity",
} as const;
